"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src253626114/src/mrt-covid19-center/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fillColor = exports.wrapper = void 0;

var react_1 = require("@emotion/react");

exports.wrapper = react_1.css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  cursor: pointer;\n"])));

var fillColor = function fillColor(isHover, isFill) {
  if (isHover) {
    return react_1.css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      fill: var(--blue-300);\n    "])));
  }

  if (isFill) {
    return react_1.css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      fill: var(--blue-400);\n    "])));
  }

  return react_1.css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    fill: var(--gray-200);\n  "])));
};

exports.fillColor = fillColor;